module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc",
      "title": "Contents"
    }
  }, [_c('h1', {
    staticClass: "toc_head"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm",
    attrs: {
      "id": "rsec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction#sec1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ts",
    attrs: {
      "id": "rsec2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter01#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 1: Pathologizing Protest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter02#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2: Americanitis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter03#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: On the Borderlines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter04#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: “They Call Us Queer, You Call Us Sick”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter05#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: No Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter06#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Tipping the Scales")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ts",
    attrs: {
      "id": "rsec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Conclusion#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments#sec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_ch",
    attrs: {
      "id": "rsec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Notes#sec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2f62c52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 75
// module chunks = 0